<template>
    <div style="padding: 20px; background: #fff;">
        <div class="flex just-between">
            <div>
                <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">增加</el-button>
            </div>
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="状态">
                    <el-select v-model="searchForm.enable" placeholder="启用状态" size="small" clearable>
                        <el-option value="true" label="启用"></el-option>
                        <el-option value="false" label="停用"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table
            :data='deptDutyList'
            :header-cell-style="{background: '#409EFF',color: '#fff'}"
            style="width:100%;border:none;"
            >
            <el-table-column type='index' label='序号' width="60"></el-table-column>
            <el-table-column prop="deptName" label="部门名称" width="300">
                <template slot-scope="scope">
                    {{scope.row.deptName}}
                    <el-tag size="small" v-if="scope.row.root">主体单位</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="profile" label="职责简介"></el-table-column>
            <el-table-column prop="linkUrl" label="链接地址"></el-table-column>
            <el-table-column prop="enable" label="启用状态" width="150">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.enable" size="small" type="success">启用</el-tag>
                    <el-tag v-if="scope.row.enable === false" size="small" type="danger">停用</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="sortCode" label="排序码" width="150"></el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="small" icon="el-icon-edit" style="margin-right:10px;" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button size="small" icon="el-icon-delete" @click="handleDelete(scope.row)" v-if="!scope.row.root">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">
            <el-form :model="deptDuty" :rules="rules" ref="editForm">
                <el-form-item
                label="部门名称"
                prop="deptName"
                :label-width="formLabelWidht"
                >
                <el-input
                    v-model="deptDuty.deptName"
                    auto-complete="off"
                    placeholder="请输入部门名称"
                    style="width: 360px"
                ></el-input>
                </el-form-item>
                <el-form-item label="主体单位" :label-width="formLabelWidht" v-if="!oldDeptDuty.root">
                <el-radio v-model="deptDuty.root" :label="true">是</el-radio>
                <el-radio v-model="deptDuty.root" :label="false">否</el-radio>
                </el-form-item>
                <el-form-item label="主体单位" :label-width="formLabelWidht" v-else>
                    <span>是</span>
                </el-form-item>
                <el-form-item
                label="链接地址"
                prop="linkUrl"
                :label-width="formLabelWidht"
                v-if="!deptDuty.root"
                >
                <el-input
                    v-model="deptDuty.linkUrl"
                    auto-complete="off"
                    placeholder="请输入链接地址"
                    style="width: 360px"
                ></el-input>
                </el-form-item>
                <el-form-item label="职责简介" :label-width="formLabelWidht">
                <el-input
                    type="textarea"
                    v-model="deptDuty.profile"
                    auto-complete="off"
                    placeholder="请输入职责简介"
                    style="width: 360px"
                ></el-input>
                </el-form-item>
                <el-form-item label="启用状态" :label-width="formLabelWidht" v-if="!deptDuty.root">
                <el-radio v-model="deptDuty.enable" :label="true">启用</el-radio>
                <el-radio v-model="deptDuty.enable" :label="false">停用</el-radio>
                </el-form-item>
                <el-form-item label="启用状态" :label-width="formLabelWidht" v-else>
                    <span>启用</span>
                </el-form-item>
                <el-form-item
                label="排序码"
                prop="sortCode"
                :label-width="formLabelWidht"
                >
                <el-input
                    type="text"
                    v-model="deptDuty.sortCode"
                    auto-complete="off"
                    placeholder="请输入数字作为排序码"
                    style="width: 360px"
                ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchForm: {
                enable: null,
                pageNum: 1,
                pageSize: 15
            },
            deptDutyList: [],
            dialogTitle: '',
            dialogVisible: false,
            formLabelWidht: "120px",
            deptDuty: {
                id: null
            },
            oldDeptDuty: {
                id: null
            },
            rules: {
                deptName: [
                { required: true, message: "请输入单位名称", trigger: "change" },
                ],
                sortCode: [
                { required: true, message: "请输入排序码", trigger: "change" },
                { pattern: /^[0-9]\d*$/, message: '排序码需为正整数', trigger: 'blur' }
                ],
                linkUrl: [{ pattern: /^(?:(http|https|ftp|smtp):\/\/)?(((?:[a-z0-9-]+\.)+[a-z]{2,20})|([0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}))(:(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3}))?(?:(?:\/(?:[\w#!:.?+=&%@!\/-])*)+\/?)?$/,
                 message: '超链接地址格式错误！示例：http://www.zfsoft.com:8080/zftal-hrm', trigger: 'blur'}
                ],
            },
        }
    },
    methods: {
        loadDeptDutyList () {
            this.dialogVisible = false
            this.$api.website.getDeptDutyPageList(this.searchForm).then(res => {
                if (res.code === 200) {
                    this.deptDutyList = res.data.content
                } else {
                    this.$message.error(res.message)
                }
            });
        },
        handleSearch () {
            this.loadDeptDutyList()
        },
        handleAdd () {
            this.deptDuty = {
                root: false,
                enable: true
            };
            this.dislogTitle = '增加职责分工'
            this.dialogVisible = true
            this.$refs.editForm?.resetFields();
        },
        handleEdit (data) {
            this.$refs.editForm?.resetFields();
            this.$api.website.getDeptDuty(data.id).then(res => {
                if (res.code === 200) {
                    this.deptDuty = res.data
                    this.oldDeptDuty = {...res.data}
                    this.dislogTitle = '修改职责分工'
                    this.dialogVisible = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleDelete (data) {
            this.$confirm('此操作将彻底删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.website.removeDeptDuty(data.id).then(res => {
                    if (res.code === 200) {
                        this.loadDeptDutyList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        handleSave () {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    if (this.deptDuty.id) {
                        this.$api.website.modifyDeptDuty(this.deptDuty).then(res => {
                            if (res.code === 200) {
                                this.$message.success('保存成功')
                                this.loadDeptDutyList()
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        this.$api.website.addDeptDuty(this.deptDuty).then(res => {
                            if (res.code === 200) {
                                this.$message.success('保存成功')
                                this.loadDeptDutyList()
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }
                }
            });
        }
    },
    mounted() {
        this.loadDeptDutyList()
    }
}
</script>

<style scoped>

</style>
